import { Avatar } from "@base-ui/react/avatar"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

function nameToInitials(name) {
  if (!name) return ""
  const parts = name.trim().toUpperCase().split(" ")
  if (parts.length <= 1) return parts[0]?.charAt(0) || ""
  return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`
}

const BaseAvatar = ({ src, name, backgroundColor, size = "md", fallback }) => {
  const sizeClasses = {
    xxs: "h-6 w-6 text-xxs",
    xs: "h-7 w-7 text-xs",
    sm: "h-8 w-8 text-sm",
    md: "h-10 w-10 text-lg",
    lg: "h-12 w-12 text-xl",
  }

  return (
    <Avatar.Root
      className={classNames(
        "inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full",
        sizeClasses[size]
      )}
    >
      <Avatar.Image
        src={src}
        alt={name ? `Profile picture for ${name}` : undefined}
        className="h-full w-full object-cover"
      />
      <Avatar.Fallback
        className={classNames(
          "flex h-full w-full items-center justify-center font-bold text-white",
          backgroundColor || "bg-gray-600"
        )}
      >
        {fallback ?? nameToInitials(name)}
      </Avatar.Fallback>
    </Avatar.Root>
  )
}

BaseAvatar.propTypes = {
  backgroundColor: PropTypes.string,
  fallback: PropTypes.node,
  name: PropTypes.string,
  size: PropTypes.oneOf(["xxs", "xs", "sm", "md", "lg"]),
  src: PropTypes.string,
}

export default BaseAvatar
